import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IVentricularAssistDeviceState } from '../../procedures/ventricularAssistDevice/store/ventricularAssistDevice.types'
import { getVentricularAssistDeviceSelector } from '../../procedures/ventricularAssistDevice/selectors'

export function* addVentricularAssistDeviceItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { items } = timeline
  const ventricularAssistDeviceState: IVentricularAssistDeviceState = yield select(getVentricularAssistDeviceSelector)
  const {
    pta,
    addToTimeline,
    key,
    time,
    date,
    assessedBy,
    comments,
    // nemsisCode,
    ventricularAssistDeviceType,
    indication,
  } = ventricularAssistDeviceState
  try {
    if (addToTimeline) {
      // const clientCorrelationId = nemsisCode ? `patient.ventricularAssistDeviceStateList_${key}` : '' // remove comment while implementing custom support
      const assessedByLabel = assessedBy?.name || ''
      const index = items.findIndex((item) => item.key === key)
      const dateTime = new Date(date || 0)
      if (time) {
        if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
        dateTime.setMinutes(+time.split(':')[1])
        dateTime.setHours(+time.split(':')[0])
      }
      const item: IItem = {
        key: key,
        // clientCorrelationId,
        grid: true,
        labelHeaderFlag: pta ? 'PTA' : '',
        labelHeader: time,
        subHeader: date,
        itemType: 'Procedures',
        event: TimelineConstants.VENTRICULAR_ASSIST_DEVICE_PROCEDURE,
        eventSubHeader: `By ${assessedByLabel},
      ${ventricularAssistDeviceType ? `Ventricular Assist Device: ${ventricularAssistDeviceType?.name},` : ''} 
      ${indication ? `Indication: ${indication?.name}` : ''}, Comments: ${comments}.`,
        rowActionType: TimelineConstants.SET_VENTRICULAR_ASSIST_DEVICE,
        defaultHref: TabConstants.VENTRICULAR_ASSIST_DEVICE_PROCEDURE,
        date: dateTime,
      }
      if (index !== -1) {
        items[index] = item
      } else {
        items.push(item)
      }
      yield put(setActivityLog(items))
      yield put(saveTimelineItems())
    }
  } catch (e) {
    yield put(throwPcrException(`addVentricularAssistDeviceItemSaga() error: ${e}`))
  }
}
export function* addVentricularAssistDeviceItemSaga() {
  yield takeLatest(
    [TimelineConstants.ADD_VENTRICULAR_ASSIST_DEVICE],
    performWithMutexHOG,
    addVentricularAssistDeviceItem
  )
}
